/*eslint-disable */
import React, { FunctionComponent, useMemo } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  BlueDivision,
  DownIcon,
  Equal,
  InfoIcon,
  MoneyReceive,
  Plus,
  Telegram,
} from "../../assets/Icons";
import { roundOffValue, selectedPurpose, transactionDetails } from "../../store";
import { UserTransactionDetails } from "../../store/store";
import IReviewPage from "./ReviewPage";
import { formatNumber, lastTwoDecimal } from "../../utils";

export const Calculation: FunctionComponent<IReviewPage.CalculationProps> = ({
  taxStep,
  setTaxStep,
}) => {
  const transactionData: UserTransactionDetails = useRecoilValue(transactionDetails);
  const [roundOffVal, setRoundOffVal] = useRecoilState(roundOffValue);
  const selectedPurposes = useRecoilValue(selectedPurpose);
  const [showInfo, setShowInfo] = React.useState<boolean>(false);

  const purposeCodes = ["S1301", "S1302"];

  const payValue = useMemo(() => {
    return roundOffVal
      ? transactionData?.totalPayInCeils.find((item: any) => item.id === 10).total_pay
      : transactionData?.total_pay;
  }, [roundOffVal, transactionData]);

  const vendorFee = useMemo(() => {
    return roundOffVal
      ? transactionData?.totalPayInCeils?.find((item: any) => item.id === 10).hop_fee
      : transactionData?.hop_fees;
  }, [roundOffVal, transactionData]);

  const totalTaxes =
    transactionData.total_tax +
    transactionData.nostro_charges +
    transactionData.nostro_charges_new +
    transactionData.hop_fees +
    transactionData.tcs;
  return (
    <div className="w-[350px] ml-28">
      {/* <div className="mb-10 font-bold font-ssp text-black -ml-28 text-md text-[16px]">
        Calculation
      </div> */}
      <div className="flex items-center justify-between my-6">
        <div className="flex flex-col flex-1 -ml-28">
          <div className="flex items-center justify-between mb-0">
            <div className="flex items-center space-x-2 text-xs font-bold text-black lg:text-base">
              <div className="mr-3 rotate-180">
                <DownIcon fillColor="rotate-90" />
              </div>
              You Send
            </div>
            <div className="flex items-center justify-between space-x-2">
              <div className="text-xs font-bold text-black lg:text-base">
                {formatNumber(transactionData.user_send)}
              </div>
              <div className="text-xs font-bold text-black lg:text-base">INR</div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mb-8">
        <div className="bg-neutral-900 w-[30px] h-[30px] rounded-full flex justify-center items-center -ml-28">
          <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            width="20"
            height="20"
          >
            <path
              stroke="#FFFFFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 17h12M4 17l3.5-3.5M4 17l3.5 3.5M7 7h13m0 0l-3.5-3.5M20 7l-3.5 3.5"
            />
          </svg>
        </div>
        <div className="flex items-center justify-between flex-1 ml-5">
          <div className="-ml-2 text-xs font-bold text-black lg:text-base">Exchange rate</div>
          <div className="flex items-center justify-between space-x-2">
            <div className="text-xs font-bold lg:text-base">
              {formatNumber(transactionData?.conversion_rate)}
            </div>
            <div className="text-xs font-bold lg:text-base">INR</div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mb-8">
        <div className="flex flex-col flex-1 -ml-28">
          <div
            // onClick={() => setTaxStep(!taxStep)}
            className="flex items-center justify-between"
          >
            <div className="flex items-center text-xs font-bold text-black lg:text-base">
              <div className="mr-3">
                <DownIcon />
              </div>
              Taxes and fees
            </div>
            <div className="flex items-center justify-between space-x-2">
              <div className="text-xs font-bold text-black lg:text-base">
                {formatNumber(totalTaxes.toFixed(2))}
              </div>
              <div className="text-xs font-bold text-black lg:text-base">INR</div>
            </div>
          </div>
          {taxStep === true && (
            <div className="mt-4 ml-[32px] animate-fade duration-0">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">{/* <Plus fillColor="#B9C9DF" /> */}</div>
                  GST
                </div>
                <div className="flex items-center justify-between space-x-2">
                  <div className="text-xs font-normal text-black lg:text-base">
                    {formatNumber(transactionData?.total_tax)}
                  </div>
                  <div className="text-xs font-normal text-black lg:text-base">INR</div>
                </div>
              </div>
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">{/* <Plus fillColor="#B9C9DF" /> */}</div>
                  {transactionData.purposeCode === "S1301" ||
                  transactionData.purposeCode === "S1302"
                    ? "Bank Fee"
                    : "Bank and Convenience Fee"}
                </div>
                <div className="flex items-center justify-between space-x-2">
                  <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                    {formatNumber(transactionData?.nostro_charges)}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                    INR
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between space-x-5">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">{/* <Plus fillColor="#B9C9DF" /> */}</div>
                  <span>NOSTRO</span>
                  <div className="flex ml-4">
                    <div className="px-2 text-white rounded bg-primary-1050">
                      {transactionData.isBene === null ? "Our" : "Bene"}
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-between space-x-2">
                  <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                    {formatNumber(transactionData?.nostro_charges_new)}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                    INR
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-[12px]">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">{/* <Plus fillColor="#B9C9DF" /> */}</div>
                  Vendor Fee
                </div>
                <div className="flex items-center justify-between space-x-2">
                  <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                    {formatNumber(lastTwoDecimal(vendorFee))}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                    INR
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-[12px] relative">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">{/* <Plus fillColor="#B9C9DF" /> */}</div>
                  <p className="mr-2">TCS</p>
                </div>
                <div className="flex items-center justify-between space-x-2">
                  <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                    {transactionData?.tcs ? formatNumber(transactionData.tcs) : 0}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-normal lg:text-base">
                    INR
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="mt-4 border border-gray-500 rounded-full"></div>
          <div className="flex items-center justify-between mt-4">
            <div className="flex items-center text-xs font-normal text-black lg:text-base">
              <div className="mr-3">
                <Equal />
              </div>
              <span className="font-bold text-black">You Pay</span>

              <div className="flex flex-row items-center justify-between ml-3">
                <button
                  onClick={() => setRoundOffVal(!roundOffVal)}
                  className={`w-full flex justify-center items-center p-1 rounded-md ${
                    roundOffVal
                      ? "bg-primary-100 text-white cursor-pointer"
                      : "bg-[#E3E3E3] text-black"
                  } ${
                    purposeCodes.includes(selectedPurposes?.purposeCode)
                      ? "cursor-not-allowed opacity-15"
                      : ""
                  }`}
                  disabled={purposeCodes.includes(selectedPurposes?.purposeCode) ? true : false}
                >
                  Round Off
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between space-x-2">
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                {formatNumber(payValue)}
              </div>
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">INR</div>
            </div>
          </div>
          <div className="flex items-center justify-between mt-4">
            <div className="flex items-center text-xs font-normal text-black lg:text-base">
              <div className="mr-3">
                <MoneyReceive />
              </div>
              <span className="font-bold text-black">They Receive</span>
            </div>
            <div className="flex items-center justify-between space-x-2">
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                {formatNumber(transactionData?.reciepient_recieve)}
              </div>
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                {transactionData.dest_currency}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
